import axios from 'axios'
import { AxiosInstance } from 'axios'
import Vue from 'vue'
import Auth from './auth'
import fileDownload from 'js-file-download'


enum HTTP {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
    PATCH = 'PATCH'
}

export enum ResponseType {
    ArrayBuffer = 'arraybuffer',
    Blob = 'blob',
    Document = 'document',
    Json = 'json',
    Text = 'text',
    Stream = 'stream'
}

export class Requester {
    public instance!: AxiosInstance
    public baseUrl!: string

    constructor(baseUrl: string, callback401?: () => void) {
        this.baseUrl = baseUrl
        this.instance = axios.create()
        this.instance.interceptors.response.use(
            response => {
                return response
            },
            error => {
                JSON.stringify(error, null, 2)
                if (error && error.response) {
                    if (error.response.status === 401) {
                        /**
                         * On peut injecter via options le logout et rerouting, par exemple.
                         */
                        if (callback401) callback401()
                    } else if (error.response.status === 302) {
                        window.location.href = error.response.request.responseURL
                    }
                }
                return Promise.reject(error)
            }
        )
    }

    private call(method: HTTP, baseUrl: string, url: string, data: any | null, allowAnonymous: boolean, responseType: ResponseType | undefined = undefined) {
        const headers = {} as any

        if (!allowAnonymous) headers['Authorization'] = Vue.prototype.$auth.bearer

        if (Vue.prototype.$database.accesSecurise) {
            headers['token-acces-renforce'] = Vue.prototype.$database.accesSecurise.token
            headers['date-acces-renforce'] = Vue.prototype.$database.accesSecurise.dateEmission
        }

        return this.instance({
            baseURL: baseUrl,
            url: url,
            method: method,
            data: data,
            headers: headers,
            withCredentials: !allowAnonymous,
            responseType: responseType
        })
    }

    public www = (url: string) => {
        return {
            get: () => {
                return this.call(HTTP.GET, url, '', null, false)
            },
            post: (data: any) => {
                return this.call(HTTP.POST, url, '', data, false)
            },
            put: (data: any) => {
                return this.call(HTTP.PUT, url, '', data, false)
            },
            delete: () => {
                return this.call(HTTP.DELETE, url, '', null, false)
            }
        }
    }

    public api = (url: string, allowAnonymous = false, responseType : ResponseType | undefined = undefined) => {
        return {
            get: () => {
                return this.call(HTTP.GET, this.baseUrl, url, null, allowAnonymous, responseType)
            },
            post: (data: any) => {
                return this.call(HTTP.POST, this.baseUrl, url, data, allowAnonymous, responseType)
            },
            patch: (data: any) => {
                return this.call(HTTP.PATCH, this.baseUrl, url, data, allowAnonymous, responseType)
            },
            postNoData: () => {
                return this.call(HTTP.POST, this.baseUrl, url, null, allowAnonymous, responseType)
            },
            put: (data: any = {}) => {
                return this.call(HTTP.PUT, this.baseUrl, url, data, allowAnonymous, responseType)
            },
            delete: (allowAnonymous = false) => {
                return this.call(HTTP.DELETE, this.baseUrl, url, null, allowAnonymous, responseType)
            },
            deleteWithData: (id: number, allowAnonymous = false) => {
                return this.call(HTTP.DELETE, this.baseUrl, url + '/' + id, null, allowAnonymous, responseType)
                // return this.call(HTTP.DELETE, this.baseUrl, url, data, allowAnonymous, responseType)
            }
        }
    }
}

export default function requester(baseUrl: string, options?: () => void) {
    const requester = new Requester(baseUrl, options)
  
    return {
      install(Vue: any) {
        Vue.prototype.$auth = Vue.observable(new Auth())
        Vue.prototype.$http = Vue.observable(requester)
      }
    }
  }

export class Files {
    public static download(name: string, blob: string) {
        fileDownload(blob, name);
        // const url = window.URL.createObjectURL(new Blob([blob]))
        // const link = document.createElement('a')
        // link.href = url
        // link.download = name
        // document.body.appendChild(link);
        // console.log(name, link.download, link)
        // link.click()
        // document.body.removeChild(link);
        // link.remove()
        // window.URL.revokeObjectURL(url)
    }
}

